import { defineSlotRecipe } from '@chakra-ui/react'

export const footer = defineSlotRecipe({
  className: 'Footer',
  slots: [
    'container',
    'wrapper',
    'navList',
    'navListItem',
    'navListLink',
    'content',
    'legal',
    'logo',
    'logoWrapper',
  ],
  base: {
    wrapper: {
      borderTop: '2px solid',
      borderTopColor: 'brand.coolgrey2',
    },
    navListLink: {
      color: 'brand.black',
      fontSize: { base: 'xs', md: 'sm' },
    },
    content: {
      borderTop: '1px solid',
      borderTopColor: 'brand.coolgrey2',
      backgroundColor: 'brand.backgroundGrey',
    },
  },
})
